import {
  FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST,
  FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_SUCCESS,
  FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_FAILURE,
  UPDATE_PAYMENT_METHOD_REQUEST,
  UPDATE_PAYMENT_METHOD_SUCCESS,
  UPDATE_PAYMENT_METHOD_FAILURE
} from './actions';

const initialState = {
  isLoading: false,
  isUpdating: false,
  hasUpdated: false,
  authorizationToken: null,
  fetchError: false,
  updateError: false
};

export default function paymentMethodsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasUpdated: false
      };
    case FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        authorizationToken: action.payload
      };
    case FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchError: true
      };

    case UPDATE_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        isUpdating: true
      };
    case UPDATE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        hasUpdated: true
      };
    case UPDATE_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        isUpdating: false,
        hasUpdated: false,
        updateError: true
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/paymentMethods/reducer.js